/* eslint-disable array-callback-return */
import "../../assets/scss/components/header.scss";
import { menuList, menuRightList, menuUserList } from "./contents";
import { Fragment, useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import user_icon from '../../assets/images/user.svg';
import alam_icon from '../../assets/images/alam.svg';
import { useDispatch } from "react-redux";
import useAuth from "../../hooks/useAuth";
import { Icon } from "../widgets/icons";
import moment from "moment";

export const Header: React.FC = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const [activeItem, setActiveItem] = useState('cugate');
  const [noMenu, setNoMenu] = useState(true);
  const { logout, isAuthenticated, user } = useAuth() as any;
  const [userMenuToggle, setUserMenuToggle] = useState(false);
  const [notificationMenuToggle, setNotificationMenuToggle] = useState(false);
  const [info, setInfo] = useState({
    country: "Germany",
    city: "Berlin",
    time: moment().format("hh:mm a"),
    temperature: 16,
    weather: "ok",
  });

  useEffect(() => {
    setNoMenu(false);
    setActiveItem("/");
    if (location.pathname.indexOf('login') > -1 || location.pathname.indexOf('register') > -1 || location.pathname.indexOf('recovery-password') > -1) {
      setNoMenu(true);
    }
    // eslint-disable-next-line array-callback-return
    menuList?.map((value, index) => {
      if (location.pathname.indexOf(value.url) > -1) {
        setActiveItem(value.key);
        return index;
      }
    });
    menuRightList?.map((value, index) => {
      if (location.pathname.indexOf(value.url) > -1) {
        setActiveItem(value.key);
        return index;
      }
    });
    if (location.pathname.indexOf('checkout') === -1 && location.pathname.indexOf('membership') === -1 && location.pathname.indexOf('http') === -1) {
      dispatch({
        type: "SET_PAGE",
        payload: activeItem,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  useEffect(() => {
    if (user && user.geo_info?.country != null) {
      setInfo({
        country: user.geo_info?.country,
        city: `${user.geo_info?.city ? user.geo_info?.city + ' ' : ''}${user.geo_info?.state}`.split(' ')[0],
        temperature: user.geo_info?.temperature,
        weather: user.geo_info?.weather,
        time: user.geo_info.time ? moment(user.geo_info.time).format("hh:mm a") : moment().format("hh:mm a"),
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  return (
    <Fragment>
      <nav
        id="navbar"
        className={"uk-navbar-container uk-navbar-transparent uk-light" + (noMenu ? " noMenu" : "")}
        onMouseLeave={() => setTimeout(() => {
          setUserMenuToggle(false);
        }, 500)}
      >
        <div className="uk-background-secondary">
          <div className="uk-container uk-container-large force-stratch-width">
            <div className="uk-navbar">
              <div className="uk-navbar-left">
                <ul className="uk-navbar-nav uk-text-large hidden-smaller-width">
                  {
                    menuList?.map((value, index) => (
                      <li key={index} className={activeItem === value.key ? "uk-active" : ""} onClick={() => setActiveItem(value.key)}>
                        {value.url.indexOf("http") === -1 ? (
                          <Link
                            onClick={(e) => { e.preventDefault(); navigate(value.url); }}
                            to={""}
                          >
                            <Icon name={value.key} color={activeItem === value.key ? `#07294C` : `white`} width={"24px"} height={"24px"} />
                            <span className="uk-margin-smaller-left uk-visible@m">
                              {value.text}
                            </span>
                          </Link>
                        ) : (
                          <a href={value.url}>
                            <Icon name={value.key} color={activeItem === value.key ? `#07294C` : `white`} width={"24px"} height={"24px"} />
                            <span className="uk-margin-smaller-left uk-visible@m">
                              {value.text}
                            </span>
                          </a>
                        )}
                      </li>
                    ))
                  }
                </ul>
              </div>
              <div className="uk-navbar-right uk-visible@m">
                <div className="d-flex">
                  <div className="space"></div>
                  <ul className="uk-navbar-nav uk-text-small --only-orange">
                    {
                      menuRightList?.map((value, index) => (
                        <li key={index} className={"hidden-small-width " + (activeItem === value.key ? "uk-active" : "")} onClick={() => setActiveItem(value.key)}>
                          <Link onClick={(e) => { e.preventDefault(); navigate(value.url); }} to={""}>
                            {value.text}
                          </Link>
                        </li>
                      ))
                    }
                  </ul>
                  <div className="space"></div>
                  <ul className="uk-navbar-nav uk-text-small">
                    <div className="weater-container">
                      <div className="icon">
                        <img src="/imgs/location.svg" alt="" />
                      </div>
                      <div className="text-content">
                        <span>{`${info.city}, ${info.country}`}</span>
                        <span>{`${info.time.toUpperCase()}  ${info.temperature > 0 ? ' +' + info.temperature : info.temperature}°C`}</span>
                      </div>
                      <div className="icon">
                        <img src={
                          "/weather_icons/" + (
                            info.weather?.toLowerCase() === "rain" ||
                              info.weather?.toLowerCase() === "snow" ||
                              info.weather?.toLowerCase() === "clouds" ||
                              info.weather?.toLowerCase() === "wind" ?
                              info.weather?.toLowerCase() : "sun"
                          ) + ".svg"
                        } style={{ width: '20px' }} alt="" />
                      </div>
                    </div>
                  </ul>
                  <div className="space"></div>
                </div>
                <ul className="uk-navbar-nav uk-text-small">
                  {
                    isAuthenticated ? (
                      <li className="ms-2 d-flex align-items-center tools-bar-right">
                        <div className="notification-wrapper focus me-3">
                          <div className="alam">
                            <img alt="alam"
                              src={alam_icon}
                              onClick={() => {
                                setNotificationMenuToggle(!notificationMenuToggle)
                                setUserMenuToggle(false)
                              }}
                            />
                          </div>
                          {user?.notifications?.filter((n: any) => n.flag === 0).length ? (
                            <div className="count">{user?.notifications.filter((n: any) => n.flag === 0).length}</div>
                          ) : (<></>)}
                          <ul
                            onMouseLeave={() => setTimeout(() => {
                              setNotificationMenuToggle(false);
                            }, 500)}
                            className={"user-menu-toggle notification-list" + (notificationMenuToggle ? " show" : "")}
                          >
                            {user?.notifications?.filter((n: any) => n.flag === 0)?.map((item: any, index2: number) => (
                              // eslint-disable-next-line jsx-a11y/anchor-is-valid
                              <li key={index2} className="notification-item"><a>{item.msg}</a></li>
                            ))}
                          </ul>
                        </div>
                        <img
                          onClick={() => {
                            setUserMenuToggle(!userMenuToggle)
                            setNotificationMenuToggle(false)
                          }}
                          alt="user"
                          className="focus"
                          src={user_icon}
                          style={{ width: '24px' }}
                        />
                        <ul
                          onMouseLeave={() => setTimeout(() => {
                            setUserMenuToggle(false);
                          }, 500)}
                          className={"user-menu-toggle" + (userMenuToggle ? " show" : "")}
                        >
                          {menuUserList?.map((item, index) => {
                            return (
                              item.key === "divider" ? (
                                <li key={index} className={item.key}></li>
                              ) : item.key === "logout" ? (
                                <li key={index} onClick={() => setUserMenuToggle(false)}>
                                  <Link to={""} onClick={() => logout()}>
                                    {item.text}
                                  </Link>
                                </li>
                              ) : item.key === "dashboard" && user && !user.counters?.artist && !user.counters?.composer && !user.counters?.release && !user.counters?.track && !user.counters?.label ? (
                                <></>
                              ) : (
                                <li
                                  className={"mb-1" + ("/" + item.key === location.pathname ? " active" : "")}
                                  key={index}
                                  onClick={() => setUserMenuToggle(false)}
                                >
                                  {item.url?.indexOf("http") === -1 ? (
                                    <Link to={"" + item.url}>
                                      {item.text}
                                    </Link>
                                  ) : (
                                    <a href={item.url} target="blank" rel="noreferrer">{item.text}</a>
                                  )}
                                </li>
                              )
                            )
                          })}
                        </ul>
                      </li>
                    ) : (
                      <li className="ms-2 tools-bar-right">
                        <Link onClick={(e) => { e.preventDefault(); navigate('login'); }} to={""}>
                          <img alt="logout" src={user_icon} style={{ width: '24px', marginRight: 5 }} />Login
                        </Link>
                      </li>
                    )
                  }
                </ul>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </Fragment>

  );
};
